import { type Team, type UserInfo } from "@repo/api";
import { Toggle } from "@repo/skapa";
import { t } from "@repo/translation";
import { useState } from "react";

import { FlexDiv } from "../FlexDiv";
import { SectionContainer } from "../SectionContainer";
import {
  SearchCoworker,
  type SearchCoworkerProps,
} from "./search/SearchCoworker";
import { SearchTeam } from "./search/SearchTeam";

export type SearchMode = "SEARCH_COWORKER" | "SEARCH_TEAM";

export interface SearchTeamCoworkerProps extends Pick<
  SearchCoworkerProps,
  "canSelectMultipleCoworkers"
> {
  mode: SearchMode;
  setMode: (newMode: SearchMode) => void;
  setCoworkers: (user: UserInfo[]) => void;
  setTeam?: (team: Team) => void;
  existingSelectedCoworkers?: UserInfo[];
  showCoworkerSearch?: boolean;
  showTeamSearch?: boolean;
}

export const isSearchMode = (mode: unknown): mode is SearchMode =>
  mode === "SEARCH_COWORKER" || mode === "SEARCH_TEAM";

export const SearchTeamCoworker = ({
  mode,
  setMode,
  setCoworkers,
  setTeam,
  canSelectMultipleCoworkers,
  existingSelectedCoworkers,
  showCoworkerSearch = true,
  showTeamSearch = true,
}: SearchTeamCoworkerProps) => {
  const [selectedCoworkers, selectCoworkers] = useState<UserInfo[]>(
    existingSelectedCoworkers ?? []
  );

  return (
    <SectionContainer>
      <FlexDiv justifyContent="center">
        <Toggle
          activeIndex={mode === "SEARCH_COWORKER" ? 0 : 1}
          onClick={(_: any, index: number) => {
            setMode(index === 0 ? "SEARCH_COWORKER" : "SEARCH_TEAM");
          }}
          buttons={[
            { text: t("label.coworker"), disabled: !showCoworkerSearch },
            { text: t("label.team"), disabled: !showTeamSearch },
          ]}
        />
      </FlexDiv>
      {mode === "SEARCH_COWORKER" && (
        <SearchCoworker
          selectedCoworkers={selectedCoworkers}
          onSelectCoworker={(users) => {
            selectCoworkers(users);
            setCoworkers(users);
          }}
          canSelectMultipleCoworkers={canSelectMultipleCoworkers}
        />
      )}
      {mode === "SEARCH_TEAM" && (
        <SearchTeam
          onSelect={(team) => {
            setTeam?.(team);
          }}
        />
      )}
    </SectionContainer>
  );
};
